import { CompetitionType } from '@models';
import type { Season } from '@models';

/**
 * Numeración de jornada **visible** de un partido.
 *
 * ⚠️ Existe porque la generación de calendarios no es homogénea (ver el aviso
 * de `single-group-cup.ts`): los partidos de **liga** se generan **0-based**
 * (`round: index`) mientras que los de la **fase de grupos de copa** se generan
 * **1-based** (`round: round + 1`). Si la plantilla suma 1 siempre, la primera
 * jornada de una copa se pinta «J2». En `fmpelota`, donde las ligas están
 * montadas como copas de un único grupo, el desfase se ve en toda la pantalla.
 *
 * Criterio, el mismo que ya aplica la app en `match-card-cup` y en
 * `match-detail`:
 *
 * - Temporada de tipo **CUP** → `round` **tal cual**. Cubre tanto la fase de
 *   grupos (1-based) como las eliminatorias, donde `round` no es una jornada
 *   sino el **número de equipos restantes** (16, 8, 4, 2, 1) y sumarle 1 no
 *   tendría ningún sentido.
 * - Cualquier otra temporada (liga) o temporada desconocida → `round + 1`,
 *   que es el comportamiento histórico y el de las plantillas de liga.
 *
 * Devuelve un número; quien llama decide la etiqueta («J3», «Jornada 3», …).
 */
export function displayRoundNumber(round: number, season: Season | null | undefined): number {
  if (!Number.isFinite(round)) return round;
  return season?.type === CompetitionType.CUP ? round : round + 1;
}
